import { PaymentPage } from "components/PaymentPage";
import { type SearchSchemaInput, createFileRoute } from "@tanstack/react-router";
import { validateStripeParams } from "utils/validateStripeParams";

/** Route for the main patient portal page, used to make a payment. */
export const Route = createFileRoute("/$token/$channel/")({
    component: PaymentPage,
    validateSearch: (search: SearchSchemaInput) => validateStripeParams(search),
});
